/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {adminResourceItemRouteResolve} from '../common/controller/admin-resource-routing';
import {RulesetResource} from '../../components/api/resources/resource/ruleset.resource';


export function rulesetStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('rulesets.ruleset', RulesetResource, null, 'app.inv', 'app');
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('ruleset-route') }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: _.merge({}, adminResourceItemRouteResolve('ruleset-edit', 'edit')),
            views: {
              'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' } } }
          }, 'Ruleset', []));
  }, adnRouterHelper);
}
